// Attaches a script and returns a promise
//  fulfilled when test returns true
//  Adapted from: http://www.phpied.com/when-is-a-stylesheet-really-loaded/
export default function attachScript (url, test){
  return new Promise(function(resolve){
    const script = document.createElement('script');
    script.src = url;

    var i = setInterval((function() {
      try {
        if (test()) {
          resolve();
          return clearInterval(i);
        }
      } catch (error) {}
    }), 10);

    return document.body.appendChild(script);
  });
}
